/* eslint-disable @typescript-eslint/no-explicit-any */
export type Role = 'user' | 'administrator' | 'management' | 'advanced_user' | 'marketing';

interface IdTokenClaimsWithRoles {
  [key: string]: unknown;

  roles?: Role[];
  oid?: string;
}

export function hasRolesClaims(claims: unknown): claims is IdTokenClaimsWithRoles {
  return typeof claims === 'object' && claims !== null && 'roles' in claims && Array.isArray((claims as any).roles);
}
